import { FundingOpportunities } from '@platform/client';
import { useState } from 'react';
import { PaginationBar } from '../../../components/PaginationBar';
import { CommunityBackButton } from '../community-home/CommunityBackButton';
import { CommunityCard } from '../CommunityCard';
import { CommunityListPanel } from '../CommunityListPanel';

export const FundingOpportunitiesPage = () => {
  const [page, setPage] = useState(0);
  const [pageSize, _] = useState(8);

  const onPageSelect = (page: number) => {
    setPage(page - 1);
  };

  const previewFundingOpportunities = FundingOpportunities.useGetFundingOpportunities({
    page,
    limit: pageSize,
    sort: 'date:ASC',
  });

  const numFundingOpportunities = FundingOpportunities.useCountFundingOpportunities();
  const numPages = Math.ceil((numFundingOpportunities.data || pageSize) / pageSize);

  return (
    <div className='p-4 flex flex-col pt-10 w-[317px] max-w-[317px] md:w-[798px] md:max-w-[798px]'>
      <CommunityBackButton />
      <h1 className='text-display-sm font-gray-700 py-10'>Funding opportunities</h1>
      <CommunityListPanel>
        {previewFundingOpportunities.data?.map((opportunity) => {
          return (
            <CommunityCard
              key={opportunity.id}
              title={opportunity.title}
              description={opportunity.description}
              date={new Date(opportunity.date)}
              link={opportunity.link ?? undefined}
              ctaVariant='secondary-gray'
              cta={'Read More'}
            />
          );
        })}
      </CommunityListPanel>
      <PaginationBar onPageSelect={onPageSelect} currentPage={page + 1} numPages={numPages} />
    </div>
  );
};
